import type { SimpleFieldConfig } from "@/components/shared/UniversalCRMTable/types";

export const pricingFields = {
  pricing_model: {
    type: "text",
    label: "Pricing Model",
    sortable: true,
    filterable: true,
    searchable: true,
    resizable: true,
    hideable: true,
    editable: true,
    formSpan: 1,
    filterType: "contains",
    width: 140,
    minWidth: 100,
    maxWidth: 180,
    placeholder: "fixed_recurring, one_time, variable_recurring, project_based",
    icon: "CreditCard",
    allowedRoles: ["wtc_admin", "wtc_crm"],
    showOnCard: true,
    cardSpan: 1,
    mobileDetailSectionId: "pricing",
  },
  base_price: {
    type: "number",
    label: "Base Price",
    sortable: true,
    filterable: true,
    resizable: true,
    hideable: true,
    editable: true,
    formSpan: 1,
    filterType: "range",
    width: 120,
    minWidth: 80,
    maxWidth: 150,
    placeholder: "79",
    icon: "DollarSign",
    allowedRoles: ["wtc_admin", "wtc_crm"],
    showOnCard: true,
    cardSpan: 1,
    mobileDetailSectionId: "pricing",
  },
  pricing_display: {
    type: "text",
    label: "Pricing Display",
    sortable: false,
    filterable: false,
    searchable: true,
    resizable: true,
    hideable: false,
    editable: true,
    formSpan: 2,
    width: 180,
    minWidth: 120,
    maxWidth: 250,
    placeholder: "$79/mo, Variable, $2,000-$5,000",
    icon: "Tag",
    allowedRoles: ["wtc_admin", "wtc_crm"],
    showOnCard: true,
    cardSpan: 1,
    mobileDetailSectionId: "pricing",
  },
  staff_line_items: {
    type: "json",
    label: "Staff Line Items",
    lineItemsType: "staff",
    sortable: false,
    filterable: false,
    resizable: true,
    hideable: true,
    editable: true,
    formSpan: 3,
    width: 250,
    minWidth: 200,
    maxWidth: 400,
    placeholder: "Add roles, hours, and optional rate overrides",
    icon: "Users",
    allowedRoles: ["wtc_admin", "wtc_crm"],
    mobileDetailSectionId: "pricing",
  },
  hard_cost_line_items: {
    type: "json",
    label: "Hard Cost Line Items",
    lineItemsType: "hard-cost",
    sortable: false,
    filterable: false,
    resizable: true,
    hideable: true,
    editable: true,
    formSpan: 3,
    width: 250,
    minWidth: 200,
    maxWidth: 400,
    placeholder: "Add categories and amounts",
    icon: "DollarSign",
    allowedRoles: ["wtc_admin", "wtc_crm"],
    mobileDetailSectionId: "pricing",
  },
  total_hours: {
    type: "number",
    label: "Total Hours",
    sortable: true,
    filterable: true,
    resizable: true,
    hideable: true,
    editable: false,
    formSpan: 1,
    filterType: "range",
    width: 120,
    minWidth: 100,
    maxWidth: 150,
    icon: "Clock",
    allowedRoles: ["wtc_admin", "wtc_crm", "wtc_employee"],
    mobileDetailSectionId: "pricing",
  },
  total_hard_costs: {
    type: "number",
    label: "Total Hard Costs",
    sortable: true,
    filterable: true,
    resizable: true,
    hideable: true,
    editable: false,
    formSpan: 1,
    filterType: "range",
    width: 140,
    minWidth: 120,
    maxWidth: 180,
    icon: "DollarSign",
    allowedRoles: ["wtc_admin", "wtc_crm", "wtc_employee"],
    mobileDetailSectionId: "pricing",
  },
  total_cost: {
    type: "number",
    label: "Total Cost",
    sortable: true,
    filterable: true,
    resizable: true,
    hideable: false,
    editable: false,
    formSpan: 1,
    filterType: "range",
    width: 140,
    minWidth: 120,
    maxWidth: 180,
    icon: "DollarSign",
    allowedRoles: ["wtc_admin", "wtc_crm", "wtc_employee"],
    mobileDetailSectionId: "pricing",
  },
} satisfies Record<string, SimpleFieldConfig>;
